import "bootstrap"; // import bootstrap js plugins

/**
 * Calling importBootstrap5 ensures the import above is done
 */
export function importBootstrap5(): void {
    // nothing to do
}